"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineHeightProperties = exports.round = exports.normalizeThemeValue = exports.isPlainObject = exports.makeCssSelectors = exports.getValueAndUnit = exports.normalizeValue = exports.getRelativeValue = exports.isRelativeValue = void 0;
function isRelativeValue(value) {
    let isPercentValue = value.endsWith('%');
    let isUnitlessValue = /\d$/.test(value);
    return isPercentValue || isUnitlessValue;
}
exports.isRelativeValue = isRelativeValue;
function getRelativeValue(value) {
    let isPercentValue = value.endsWith('%');
    return isPercentValue
        ? Number.parseInt(value.replace('%', ''), 10) / 100
        : Number.parseFloat(value);
}
exports.getRelativeValue = getRelativeValue;
function normalizeValue(value, root, fs) {
    value = Array.isArray(value) ? value[0] : value;
    if (value.endsWith('px'))
        return Number.parseFloat(value.replace('px', ''));
    if (value.endsWith('rem'))
        return root * Number.parseFloat(value.replace('rem', ''));
    if (isRelativeValue(value) && fs !== undefined) {
        return fs * getRelativeValue(value);
    }
    return Number.parseInt(value, 10);
}
exports.normalizeValue = normalizeValue;
const cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
function getValueAndUnit(value) {
    if (typeof value !== 'string')
        return [value, ''];
    let matchedValue = cssRegex.exec(value);
    if (matchedValue !== null)
        return [Number.parseFloat(value), matchedValue[2]];
    return [Number.parseInt(value, 10), undefined];
}
exports.getValueAndUnit = getValueAndUnit;
function makeCssSelectors(fontFamily, sizeName, leading, className) {
    return (`.font-${fontFamily}.text-${sizeName}.leading-${leading}.${className},` +
        `.font-${fontFamily} .text-${sizeName}.leading-${leading}.${className},` +
        `.font-${fontFamily} .text-${sizeName} .leading-${leading}.${className},` +
        `.text-${sizeName} .font-${fontFamily}.leading-${leading}.${className},` +
        `.text-${sizeName} .font-${fontFamily} .leading-${leading}.${className}`);
}
exports.makeCssSelectors = makeCssSelectors;
function isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== '[object Object]') {
        return false;
    }
    let prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
}
exports.isPlainObject = isPlainObject;
/**
 * Returns a value based on the core theme section.
 * Adapted from Tailwind internals.
 *
 * @see https://github.com/tailwindlabs/tailwindcss/blob/30ea5b14a631b6f68e56740c3d09bb54fcbad08a/src/util/transformThemeValue.js
 */
function normalizeThemeValue(key, value) {
    switch (key) {
        case 'fontSize':
        case 'lineHeight':
            if (typeof value === 'function')
                value = value({});
            if (Array.isArray(value))
                value = value[0];
            return value;
        case 'fontFamily':
            if (typeof value === 'function')
                value = value({});
            if (Array.isArray(value))
                value = value.join(', ');
            return value;
        default:
            if (typeof value === 'function')
                value = value({});
            return value;
    }
}
exports.normalizeThemeValue = normalizeThemeValue;
function round(value) {
    return Number.parseFloat(value.toFixed(4)).toString();
}
exports.round = round;
/**
 * Takes a theme value for lineHeight and returns the `line-height` property,
 * as well as a `--line-height-offset` custom property.
 */
function lineHeightProperties(lineHeight, rootSize = 16) {
    if (lineHeight === undefined)
        return {};
    let lineHeightActual = isRelativeValue(lineHeight)
        ? `calc(${getRelativeValue(lineHeight)} * var(--font-size-px))`
        : normalizeValue(lineHeight, rootSize);
    return {
        '--line-height-offset': `calc((((var(--line-height-scale) * var(--font-size-px)) - ${lineHeightActual}) / 2) / var(--font-size-px))`,
        'line-height': lineHeight,
    };
}
exports.lineHeightProperties = lineHeightProperties;
